import { render, staticRenderFns } from "./Timeline.vue?vue&type=template&id=f970a42e&scoped=true"
import script from "./Timeline.vue?vue&type=script&lang=js"
export * from "./Timeline.vue?vue&type=script&lang=js"
import style0 from "./Timeline.vue?vue&type=style&index=0&id=f970a42e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f970a42e",
  null
  
)

export default component.exports